
export const UPDATE_SELECTED_SELLERS = 'PROGRAMS__UPDATE_SELECTED_SELLERS';

export const GET_UPDATED_SELLERS = 'PROGRAMS__GET_UPDATED_SELLERS';
